import React from 'react';
import ReaderForm from './components/ReaderForm';

const ReaderEditPage: React.FC = () => {
  // Title is set at the application level
  return <ReaderForm isEdit={true} />;
};

export default ReaderEditPage;